import { render, staticRenderFns } from "./ProductsEdit.vue?vue&type=template&id=44fc62a1&scoped=true"
import script from "./ProductsEdit.vue?vue&type=script&lang=js"
export * from "./ProductsEdit.vue?vue&type=script&lang=js"
import style0 from "./ProductsEdit.vue?vue&type=style&index=0&id=44fc62a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fc62a1",
  null
  
)

export default component.exports